import React from "react"
import { Route, Switch } from "react-router-dom"
import { ConnectedRouter } from "react-router-redux"
import { connect } from "react-redux"

import "./config/moment-locale"
import { history } from "./store/configure-store"

import Main from "./components/Main"
import Login from "./components/login/Login"
import PrivateRoute from "./components/common/PrivateRoute"

import "font-awesome/css/font-awesome.css"
import "react-datepicker/dist/react-datepicker.css"
import "react-select/dist/react-select.css"
import "./assets/css/style.css"

const App = ({ authenticated, isRehydrating, redirectPath }) => (
    <ConnectedRouter history={history}>
        <div>
            <Switch>
                <Route
                    exact
                    path="/login"
                    render={(props) => (
                        <Login {...props} redirectPath={redirectPath} />
                    )}
                />
                <PrivateRoute
                    authenticated={authenticated}
                    isRehydrating={isRehydrating}
                    render={(props) => (
                        <Main {...props} redirectPath={redirectPath} />
                    )}
                />
            </Switch>
        </div>
    </ConnectedRouter>
)

const mapStateToProps = ({
    authentication: { authenticated, permissions },
    navbar,
    presentation,
}) => {
    let redirectPath
    // TODO: also look at what they previously were visiting before hitting the login page
    // to redirect them back to what they were looking at
    if ((permissions || []).includes("r_map")) {
        redirectPath = "/knowledge"
    } else {
        redirectPath = navbar && (navbar[0] || {}).link
    }
    return {
        authenticated,
        isRehydrating: presentation.authentication.isRehydrating,
        redirectPath,
    }
}

const mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(App)
